<template>
    <div class="crud-wrapper">
        <crud-toolbar :modalMode="modalMode" :newState="newState" :showBack="false" :title="modalTitle"
                      @onCommand="toolbarCommand"></crud-toolbar>

        <crud-form :modal-mode="modalMode" :ref="formName" v-model="validForm">

            <v-layout row wrap>
                <a-autocomplete-field :modalForm="ClientForm" :suggestions="formData.clientDetails" @onSelect="onClientSelect"
                                      allowEdit allowNew autofocus label="Cliente"
                                      obj="client/exchangeStats"
                                      placeholder="selecionar cliente"
                                      ref="transferClient"
                                      v-model="formData.clientId"
                                      validate="required">
                    <template slot="content" slot-scope="{data}">
                        <v-layout column>
                            <v-list-tile-title style="height: 18px;" v-text="data.name"></v-list-tile-title>
                            <v-list-tile-sub-title class="py-0">{{`${data.mobile_number} / ${data.city}`}}
                            </v-list-tile-sub-title>
                        </v-layout>
                    </template>
                </a-autocomplete-field>

                <v-flex md8 xs6>
                    <v-layout row wrap>
                        <a-text-field label="Observações" v-model="formData.notes" xs12></a-text-field>
                    </v-layout>
                </v-flex>

                <v-flex md4 pa-0 xs6>
                    <a-number-field id="test" label="Valor do Pgto" number-mask="us"
                                    v-model="formData.amount" validate="gtZero"></a-number-field>
                </v-flex>

                <v-flex xs12>
                    <v-slide-y-transition>
                        <v-card flat v-if="formData.clientId  && !fromExchanges">
                            <v-card-title class="subheading">Selecionar cheque para vincular recebimento</v-card-title>
                            <v-card-text>
                                <a-data-grid :columns="gridColumns" :filter-by="{clientId: formData.clientId}" :options="gridOptions"
                                             @onSelectionChange="checkSelected"
                                             multi-select obj="exchange"
                                             ref="aGrid" v-model="formData.selectedCheck"></a-data-grid>
                                <v-layout align-center clas="pa-0"
                                          row style="background-color: #f1f1f1; height: 25px; font-size:13px;">
                                    <v-flex class="pa-0 caption text-xs-center" xs2>Em aberto</v-flex>
                                    <v-flex class="pa-0 blue--text caption text-xs-center" xs2>Depositado</v-flex>
                                    <v-flex class="pa-0 red--text caption text-xs-center" xs2>Devolvido</v-flex>
                                    <v-flex class="pa-0 green--text text-xs-center caption" xs2>Quitado</v-flex>
                                    <v-flex class="pa-0 orange--text text-xs-center caption" xs3>Reapresentado</v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-slide-y-transition>
                </v-flex>
            </v-layout>

            <template slot="rightContent">
                <!--SELECTED CLIENT-->
                <v-scroll-y-transition>
                    <v-card class="pb-3" transition="slide-y-reverse-transition"
                            v-if="formData.clientId && !fromExchanges">

                        <!--Client ID Image-->
                        <v-img :aspect-ratio="idRatio" :src="media" @click="idZoom = (hasID) ? !idZoom : false"
                               gradient="to top, rgba(0,0,0,.8), rgba(255,255,255,0) 50px">
                            <v-container class="pa-0" fill-height fluid>
                                <v-layout class="ma-0 pa-0" column fill-height justify-start>
                                    <v-flex class="title" text-xs-center xs12>

                                    </v-flex>
                                    <v-flex class="pa-0" style="max-height: 60px;" xs12>
                                        <v-layout @click.stop="idZoom = idZoom" align-end class="pa-0 ma-0" fill-height justify-space-between
                                                  row xs12>
                                            <v-flex class="pa-0">
                                                <v-tooltip bottom>
                                                    <v-btn @click.stop="editClient" dark icon slot="activator" small>
                                                        <v-icon small>fas fa-pen-alt</v-icon>
                                                    </v-btn>
                                                    Editar
                                                </v-tooltip>
                                            </v-flex>

                                            <v-flex class="pa-0" text-xs-right>
                                                <v-tooltip bottom>
                                                    <v-btn :disabled="!hasID" @click.stop="idZoom = !idZoom" dark icon
                                                           slot="activator"
                                                           small>
                                                        <v-icon small v-if="!idZoom">fas fa-search-plus</v-icon>
                                                        <v-icon small v-if="idZoom">fas fa-search-minus</v-icon>
                                                    </v-btn>
                                                    Ver Detalhes
                                                </v-tooltip>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-img>

                        <!--Client Status Button-->
                        <v-tooltip bottom style="z-index: 1;">
                            <v-btn :class="clientStatus.color" dark fab icon slot="activator"
                                   style="margin-top: -30px; margin-left: 45%; ">
                                <v-icon>{{clientStatus.icon}}</v-icon>
                            </v-btn>
                            {{clientStatus.tooltip}}
                        </v-tooltip>

                        <v-card-title class="pt-1 headline text-truncate text-no-wrap" primary-title>
                            {{clientData.name}}
                        </v-card-title>

                        <!--Client Data-->
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex class="py-0 red--text" sm2 v-if="clientData.ex_balance_due" xs3>Débitos:
                                </v-flex>
                                <v-flex class="py-0 red--text font-weight-bold" sm10 v-if="clientData.ex_balance_due"
                                        xs9>{{clientData.ex_balance_due | fmtMoney}}
                                </v-flex>
                                <v-flex class="py-0 grey--text" sm2 xs3>Fed. ID:</v-flex>
                                <v-flex class="py-0" sm4 xs9>{{clientData.federalId}}</v-flex>
                                <v-flex class="py-0 grey--text" sm2 xs3>Fone:</v-flex>
                                <v-flex class="py-0" sm4 xs9>{{clientData.mobile_number}}</v-flex>

                                <v-flex class="py-0 grey--text" sm2 xs3>Email:</v-flex>
                                <v-flex class="py-0" sm10 xs9>{{clientData.main_email}}</v-flex>

                                <v-flex class="py-0 grey--text" sm2 xs3>Endereço:</v-flex>
                                <v-flex class="py-0" sm10 xs9>{{clientData.address}}</v-flex>

                                <v-flex class="py-0 grey--text" sm2 xs3>Cidade:</v-flex>
                                <v-flex class="py-0" sm4 xs9>{{clientData.city}}/{{clientData.state}}</v-flex>
                                <v-flex class="py-0 grey--text" sm2 xs3>CEP:</v-flex>
                                <v-flex class="py-0" sm4 xs9>{{clientData.zipcode}}</v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-scroll-y-transition>

            </template>
        </crud-form>

    </div>
</template>

<script>
   import numeral from 'numeral';
   import CrudFormClass from "@consigmais-team/vue-common/layout/crudPage/crudFormClass";

   import ClientForm from './ClientForm';


   export default CrudFormClass.extend({

      name: 'ReceivePaymt',

      data() {
         return {
            title: 'Receber Pagamento',
            formName: 'receivePayment',

            ClientForm,

            idZoom: false,

            formData: {
               id: null,
               companyId: this.$store.state.company.selectedStore,
               done_at: null,
               typeId: 5,
               clientId: null,
               exchangeId: null,
               amount: 0,
               notes: null,
               selectedCheck: null,
               selectedBalance: 0
            },

            clientData: {
               id: null,
               name: null,
               blocked: false,
               federalId: null,
               address: null,
               address2: null,
               city: null,
               state: null,
               zipcode: null,
               mobile_number: null,
               main_email: null,
               birth: null,
               avatar: null,
               ex_pending_amt: 0,
               ex_bounced_amt: 0,
               ex_balance_due: 0,
            },

            gridColumns: [
               {
                  dataField: 'done_at',
                  caption: 'Data',
                  dataType: 'date',
                  format: 'MM/dd/yyyy',
                  width: 90
               },
               {
                  dataField: 'employerName',
                  caption: 'Empresa',
                  minWidth: 110
               },
               {
                  dataField: 'balance_due',
                  caption: 'Débito',
                  dataType: 'number',
                  format: {type: 'currency', precision: 2},
                  minWidth: 80
               },
               {
                  dataField: 'check_amount',
                  caption: 'Cheque',
                  dataType: 'number',
                  format: {type: 'currency', precision: 2},
                  minWidth: 80
               },
               {
                  dataField: 'fee_total',
                  caption: 'Taxa',
                  dataType: 'number',
                  format: {type: 'currency', precision: 2},
                  minWidth: 80
               },
               {
                  dataField: 'net_total',
                  caption: 'Liquido',
                  dataType: 'number',
                  format: {type: 'currency', precision: 2},
                  minWidth: 80
               }
            ],


            gridOptions: {
               selection: {
                  mode: 'multiple',
                  allowSelectAll: false,
                  showCheckBoxesMode: 'always'
               },
               /*summary: {
                  texts: {sum: '', count: '{0} Remessas'},
                  totalItems: [
                     {
                        column: 'client_name',
                        valueFormat: {type: 'fixedPoint', precision: 0},
                        summaryType: 'count'
                     },
                     {
                        column: 'amount_us',
                        valueFormat: {type: 'fixedPoint', precision: 2},
                        summaryType: 'sum'
                     },
                     {
                        column: 'fee_value',
                        valueFormat: {type: 'fixedPoint', precision: 2},
                        summaryType: 'sum'
                     },
                     {
                        column: 'total',
                        valueFormat: {type: 'fixedPoint', precision: 2},
                        summaryType: 'sum'
                     },
                     {
                        column: 'amount_rs',
                        valueFormat: {type: 'fixedPoint', precision: 2},
                        summaryType: 'sum'
                     }
                  ]
               },*/
               onRowPrepared: (info) => {
                  if (info.rowType === "data") {
                     if (info.data.statusId === 3)
                        info.rowElement.addClass("red--text");
                     else if (info.data.statusId === 2)
                        info.rowElement.addClass("blue--text");
                     else if (info.data.statusId === 4)
                        info.rowElement.addClass("green--text");
                     else if (info.data.statusId === 5)
                        info.rowElement.addClass("orange--text");
                  }
               }
            }

         }
      },

      watch: {
         'formData.selectedCheck': function (val) {
            this.formData.exchangeId = +val.join() || null;
         }
      },


      computed: {
         fromExchanges() {
            return Boolean(this.refData);
         },

         hasID() {
            return Boolean(this.clientData.avatar);
         },

         idRatio() {
            let mediaRatio = 16 / 10;
            if (this.clientData.avatar && this.clientData.avatar.size && this.clientData.avatar.size.h)
               mediaRatio = (this.clientData.avatar.size.w - 150) / this.clientData.avatar.size.h;

            return this.idZoom ? mediaRatio : 4.75
         },

         clientStatus() {
            let currentStatus = 0;
            let status = [
               {icon: 'far fa-thumbs-up', tooltip: 'Cliente Ok!', color: 'primary'},
               {icon: 'fas fa-exclamation-triangle', tooltip: 'Há transações em aberto!', color: 'amber'},
               {icon: 'fas fa-times', tooltip: 'Há Cheques Devolvidos!', color: 'red'},
               {icon: 'fas fa-ban', tooltip: 'Cliente está Bloqueado!', color: 'red'}
            ];
            if (this.clientData) {
               if (this.clientData.blocked)
                  currentStatus = 3;
               else if (this.clientData.ex_bounced_amt > 0)
                  currentStatus = 2;
               else if (this.clientData.ex_pending_amt > 0 || this.clientData.ex_balance_due > 0)
                  currentStatus = 1;
            }

            return status[currentStatus];
         },

         media() {
            let media = '/static/images/no-id.jpg';

            if (this.clientData.avatar) {
               let mediaPath = 'http://res.cloudinary.com/rtravelsvs/';  //this.$store.state.settings.baseUrl.path;
               let transformation = (this.clientData.avatar.format === 'pdf') ? 'e_improve,h_480,w_960,c_thumb,g_auto,e_trim:30' : 'c_limit,e_trim:30,h_480,w_960';
               // media = mediaPath + `image/upload/c_limit,h_480,w_960/`;
               media = mediaPath + `image/upload/${transformation}/`;
               media += this.clientData.avatar.name;
               media = media.replace('.pdf', '.jpg');
            }

            return media

         }

      },

      methods: {
         saveConfirmation() {
            if (numeral(this.formData.amount).value() > this.formData.selectedBalance) {
               let diff = numeral(this.formData.amount).value() -  this.formData.selectedBalance;
               return new Promise((resolve, reject) => {
                  this.$msg.confirm({
                     title: 'Confirma mesmo assim?',
                     message: `Recebimento está ${numeral(diff).format('$ 0,0.00')} maior que o débito. A diferença será lançada como Taxa Extra.`,
                     actions: ['Sim', 'Não'],
                     defaultAction: 0
                  }).then((action) => (action === 0) ? resolve(true) : reject(false));
               });
            }

            return Promise.resolve();

         },

         beforeSave() {
            let skipSave = false;
            if (!this.formData.selectedCheck) {
               skipSave = true;
               this.$notifyUser({
                  type: 'error',
                  message: 'Selecione um cheque para vincular este recebimento!'
               })
            }

            if (this.formData.selectedCheck && this.formData.selectedCheck.length > 1) {
               skipSave = true;
               this.$notifyUser({
                  type: 'error',
                  message: 'Selecione apenas um cheque!'
               })
            }




            return skipSave;
         },

         editClient() {
            this.$refs.transferClient.editRecord(this.formData.clientId);
         },

         onClientSelect(data) {
            this.clientData = data;
         },

         onHistoryClick() {
            this.showHistory = !this.showHistory;
            if (this.showHistory)
               setTimeout(() => this.$vuetify.goTo(this.$refs.aGrid, {
                  easing: 'easeInOutCubic',
                  offset: 0,
                  duration: 550
               }), 200);
         },

         checkSelected(selectedChecks) {

            if (selectedChecks && selectedChecks.data.length)
               this.formData.selectedBalance = selectedChecks.data[0].balance_due;
            else
               this.formData.selectedBalance = 0;

            if (selectedChecks.keys.length > 1) {
               this.$notifyUser({
                  type: 'warning',
                  message: 'Selecione apenas um cheque por recebimento.'
               })
            }
         }
      },

      mounted() {
         if (this.refData) {
            this.formData.companyId = this.$store.state.company.selectedStore || this.refData.companyId;
            this.formData.clientId = this.refData.clientId;
            this.formData.selectedCheck = [this.refData.id];
            this.formData.selectedBalance = this.refData.balance_due;
            // this.formData.exchangeId = this.refData.id;
         }
      }


   })

</script>

<style scoped>


</style>








// WEBPACK FOOTER //
// src/pages/ReceivePaymt.vue